var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":"","border":false,"safe-area-inset-top":true},on:{"click-left":_vm.onClickLeft}})],1),_c('div',{staticClass:"box"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.msg)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }